import { useRef } from 'react';

interface BlogSearchBarProps {
  value: string;
  onChange: (val: string) => void;
  totalResults: number;
  totalPosts: number;
}

export default function BlogSearchBar({ value, onChange, totalResults, totalPosts }: BlogSearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="w-full max-w-2xl mx-auto">
      {/* Input */}
      <div className="relative group">
        <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
          <div className="w-5 h-5 flex items-center justify-center text-gray-400 group-focus-within:text-primary transition-colors">
            <i className="ri-search-2-line text-lg"></i>
          </div>
        </div>
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Buscar por palavra-chave, tema ou categoria..."
          className="w-full pl-12 pr-12 py-4 bg-white rounded-xl border-2 border-white/80 focus:border-primary focus:outline-none font-body text-sm text-gray-800 placeholder-gray-400 shadow-lg transition-all"
        />
        {value && (
          <button
            onClick={() => { onChange(''); inputRef.current?.focus(); }}
            className="absolute inset-y-0 right-0 pr-5 flex items-center cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-700 transition-colors">
              <i className="ri-close-circle-fill text-lg"></i>
            </div>
          </button>
        )}
      </div>

      {/* Result feedback */}
      {value.trim() && (
        <div className="mt-3 text-center">
          <span className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white text-xs font-body px-4 py-1.5 rounded-full">
            {totalResults > 0 ? (
              <>
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-article-line text-xs"></i>
                </div>
                <strong>{totalResults}</strong> {totalResults === 1 ? 'artigo encontrado' : 'artigos encontrados'} para
                <span className="font-semibold">&ldquo;{value}&rdquo;</span>
              </>
            ) : (
              <>
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-search-eye-line text-xs"></i>
                </div>
                Nenhum resultado para
                <span className="font-semibold">&ldquo;{value}&rdquo;</span>
              </>
            )}
          </span>
        </div>
      )}

      {/* Hint when idle */}
      {!value.trim() && (
        <div className="mt-3 flex items-center justify-center gap-3 flex-wrap">
          {['Silent Disco', 'Treinamentos', 'Conferência', 'Casamentos'].map(hint => (
            <button
              key={hint}
              onClick={() => onChange(hint)}
              className="bg-white/20 hover:bg-white/30 text-white text-xs font-body px-3 py-1 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              {hint}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
